import React from "react";

const NounProAppsList = ({ showCaptions }) => {
    const ulClasses = showCaptions
        ? "noun-pro-apps-list show-captions row margin-t-s margin-b-s"
        : "noun-pro-apps-list hide-captions";
    const columnClasses = showCaptions
        ? "column col-lg-6 col-md-6 col-sm-6 col-xs-6"
        : "column";

    return (
        <ul className={ulClasses}>
            <li className={columnClasses}>
                <ul>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/apple.svg"
                            alt="Noun Project for Mac"
                            title="Drag and drop from your desktop."
                            width="18"
                            height="18"
                        />
                        <span className="caption">Mac Users</span>
                    </li>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/adobe-illustrator.svg"
                            alt="Noun Project for Adobe Illustrator"
                            title="Noun Project for Adobe Illustrator"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Adobe Illustrator</span>
                    </li>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/adobe-photoshop.svg"
                            alt="Noun Project for Adobe Photoshop"
                            title="Noun Project for Adobe Photoshop"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Adobe Photoshop</span>
                    </li>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/adobe-indesign.svg"
                            alt="Noun Project for Adobe InDesign"
                            title="Noun Project for Adobe InDesign"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Adobe InDesign</span>
                    </li>
                </ul>
            </li>
            <li className={columnClasses}>
                <ul>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/google-slides.svg"
                            alt="Noun Project for Google Slides"
                            title="Noun Project for Google Slides"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Google Slides</span>
                    </li>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/google-docs.svg"
                            alt="Noun Project for Google Docs"
                            title="Noun Project for Google Docs"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Google Docs</span>
                    </li>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/microsoft-powerpoint.svg"
                            alt="Noun Project for Microsoft PowerPoint"
                            title="Noun Project for Microsoft PowerPoint"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Microsoft PowerPoint</span>
                    </li>
                    <li className="app">
                        <img
                            src="/web-images/third-party-logos/microsoft-word.svg"
                            alt="Noun Project for Microsoft Word"
                            title="Noun Project for Microsoft Word"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Microsoft Word</span>
                    </li>
                </ul>
            </li>
        </ul>
    );
};

export default NounProAppsList;
